import { WSAvatar, WSFlexBox, WSText } from "@wingspanhq/fe-component-library";
import { useMethodLabelProps } from "../LabelMethod/useMethodLabelProps";
import { MethodType } from "../ManageMethods/types";

export type LabelMethodProps = {
  type: MethodType;
  id: string;
  hideNumbers?: boolean;
};

export const SplitMethod: React.FC<LabelMethodProps> = props => {
  const { isLoading, label } = useMethodLabelProps(props.id, props.type);

  return (
    <WSFlexBox alignItems="center" gap="S" shimmer={isLoading}>
      {label?.avatar && <WSAvatar size="S" {...label.avatar} />}
      <WSText.ParagraphSm color="gray500">
        {[
          label?.link?.label,
          props.hideNumbers ? undefined : label?.secondaryText
        ]
          .filter(Boolean)
          .join(" ")}
      </WSText.ParagraphSm>
    </WSFlexBox>
  );
};
